import React from "react";

// Renders just the video element (or iframe for embeds).
// Failure overlay and nav arrows are handled by the parent.
type VideoPlayerProps = {
  videoRef: React.RefObject<HTMLVideoElement>;
  currentEmbedUrl?: string;
  title?: string | null;
  // video element attrs
  controls?: boolean;
  loop?: boolean;
  playsInline?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onError: () => void;
  // mobile pointer handlers (optional — desktop omits these)
  onPointerDown?: React.PointerEventHandler<HTMLVideoElement>;
  onPointerMove?: React.PointerEventHandler<HTMLVideoElement>;
  onPointerUp?: React.PointerEventHandler<HTMLVideoElement>;
};

export default function VideoPlayer({
  videoRef,
  currentEmbedUrl,
  title,
  controls,
  loop,
  playsInline,
  className,
  style,
  onError,
  onPointerDown,
  onPointerMove,
  onPointerUp,
}: VideoPlayerProps) {
  if (currentEmbedUrl) {
    return (
      <iframe
        src={currentEmbedUrl}
        title={title || "Embedded video"}
        className={className}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    );
  }

  return (
    <video
      ref={videoRef}
      className={className}
      controls={controls}
      loop={loop}
      playsInline={playsInline}
      preload="metadata"
      onError={onError}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      style={style}
    >
      Your browser does not support the video tag.
    </video>
  );
}
